/* JerseyFC — mobile tactile / native-feel layer.
   Makes the site feel like a polished native app on touch devices: every tap gives
   instant physical feedback (press-in + subtle haptic), the ugly grey tap-flash is gone,
   and scrollers don't chain into the page bounce. Everything here is gated to touch
   devices — desktop (mouse/hover) is completely untouched. Honest by design: pure
   responsiveness, no fake urgency/scarcity. Global; loaded once from theme.liquid. */
(function () {
  'use strict';

  var coarse = (window.matchMedia && window.matchMedia('(pointer: coarse)').matches) ||
               ('ontouchstart' in window);

  /* ── 1. Press feel (CSS) ──────────────────────────────────────────────
     Injected into <head> at runtime so it lands after the stylesheets and wins
     the cascade. The press states sit inside (hover:none)+(pointer:coarse) so only
     phones/tablets get them — a mouse never triggers :active scale. */
  var css = document.createElement('style');
  css.id = 'jfc-tactile-style';
  css.textContent = [
    /* kill the default grey/blue tap flash everywhere — replaced by our own feedback */
    '*{-webkit-tap-highlight-color:transparent;}',

    '@media (hover:none) and (pointer:coarse){',
      /* every button / CTA / nav item / disclosure depresses + dims on touch */
      'button,[role="button"],.button,summary,.product-form__submit,.jfc-sk-btn,' +
      '.cart__checkout-button,.shopify-payment-button__button,.jfc-pc__atc,.jfc-cart-up__add,' +
      '.jfc-wc__cta,.jfc-coll-mast__cta,.jfc-hero__cta,.jfc-newsletter button,.jfc-contact button,' +
      '.jfc-request-kit button,.quantity__button,.jfc-coll-toolbar__view-btn,.jfc-coll-pagination a,' +
      '.header__menu-item,.menu-drawer__menu-item,.list-menu__item,.jfc-leagues__row{' +
        'transition:transform .13s cubic-bezier(.2,.85,.25,1),filter .13s ease;' +
        'touch-action:manipulation;' +
      '}',
      'button:active,[role="button"]:active,.button:active,summary:active,.product-form__submit:active,' +
      '.jfc-sk-btn:active,.cart__checkout-button:active,.shopify-payment-button__button:active,' +
      '.jfc-pc__atc:active,.jfc-cart-up__add:active,.jfc-wc__cta:active,.jfc-coll-mast__cta:active,' +
      '.jfc-hero__cta:active,.jfc-newsletter button:active,.jfc-contact button:active,' +
      '.jfc-request-kit button:active,.header__menu-item:active,.menu-drawer__menu-item:active,' +
      '.list-menu__item:active,.jfc-leagues__row:active{' +
        'transform:scale(.965);filter:brightness(.93);' +
      '}',
      /* small icon controls press harder */
      '.quantity__button:active,.jfc-coll-toolbar__view-btn:active,.jfc-coll-pagination a:active{' +
        'transform:scale(.88);filter:brightness(.9);' +
      '}',
      /* product / collection / world-cup / featured cards depress as a whole */
      '.jfc-pc,.jfc-wc__card,.card-wrapper,.jfc-featured__card,.jfc-foryou__card,.jfc-showcase__card{' +
        'transition:transform .16s cubic-bezier(.2,.85,.25,1);' +
      '}',
      '.jfc-pc:active,.jfc-wc__card:active,.card-wrapper:active,.jfc-featured__card:active,' +
      '.jfc-foryou__card:active,.jfc-showcase__card:active{' +
        'transform:scale(.978);' +
      '}',
      /* size / variant chips */
      '.product-form__input label{transition:transform .12s ease;}',
      '.product-form__input label:active{transform:scale(.93);}',
    '}',

    /* momentum + no scroll-chaining on the app-like horizontal rails & the cart drawer */
    '.jfc-wc__rail,.jfc-showcase__rail,.jfc-foryou__rail,cart-drawer .drawer__inner,' +
    '.cart-drawer__items,.drawer__contents{overscroll-behavior:contain;-webkit-overflow-scrolling:touch;}'
  ].join('');
  (document.head || document.documentElement).appendChild(css);

  /* ── 2. Haptics ───────────────────────────────────────────────────────
     navigator.vibrate works on Android Chrome (and is correctly a no-op on iOS,
     where Apple blocks web vibration — those users still get the visual press feel).
     Vibration needs a user gesture, so we only ever fire it from inside a real
     click/change event. Patterns are deliberately tiny (≈ a native tap tick). */
  var canBuzz = coarse && ('vibrate' in navigator);
  function buzz(ms) { if (canBuzz) { try { navigator.vibrate(ms); } catch (e) {} } }

  var PRIMARY = '.product-form__submit,.jfc-sk-btn,.cart__checkout-button,' +
                '.shopify-payment-button__button,.jfc-cart-up__add';
  var CONTROL = '.button,button,[role="button"],.quantity__button,[name="plus"],[name="minus"],' +
                '.jfc-pc__atc,.jfc-wc__card,.jfc-pc__img-link,.jfc-coll-toolbar__view-btn,' +
                '.jfc-wc__cta,.jfc-coll-mast__cta,#cart-icon-bubble';

  document.addEventListener('click', function (e) {
    if (!canBuzz || !e.target.closest) return;
    if (e.target.closest(PRIMARY)) buzz(16);          /* commerce action → a touch richer */
    else if (e.target.closest(CONTROL)) buzz(9);      /* any other control → light tick */
  }, true);

  /* size / variant selection → a crisp little tick */
  document.addEventListener('change', function (e) {
    if (!canBuzz || !e.target.closest) return;
    if (e.target.closest('variant-radios,variant-selects,.product-form__input,fieldset.product-form__input')) buzz(11);
  }, true);
})();
